import React from "react";
import { TextField, Button, List, ListItem } from "../atoms";
import { UilSearch, UilTimes } from "@iconscout/react-unicons";
import PropTypes from "prop-types";

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

const SearchBar = (props) => {
  const {
    withList = false,
    placeholder = "Searchbar",
    close,
    closeAction,
    value,
    name,
    onClickSearch,
    onChange,
    result = options,
    className = "w-full",
    label = "",
    disabled = false,
  } = props;

  const [show, setShow] = React.useState(false);
  const [keyword, setKeyword] = React.useState(value);

  const resultOnfilter = React.useMemo(() => {
    if (!keyword) return result;

    return result.filter((opt) => {
      return opt.label.toLowerCase().includes(keyword.toLowerCase());
    });
  }, [keyword, result]);

  const onSelectDefault = (value) => {
    onClickSearch(value);
    setKeyword(value);
    setShow(false);
  };

  React.useEffect(() => {
    setKeyword(value);
  }, [keyword]);

  return (
    <div className={`relative ${className}`}>
      <TextField
        disabled={disabled}
        label={label}
        placeholder={placeholder}
        variant={value.length || keyword.length ? "primary" : "secondary"}
        name={name}
        value={withList ? keyword : value}
        onClick={() => setShow(!show)}
        onChange={withList ? (e) => setKeyword(e.target.value) : (e) => onChange(e.target.value)}
        leftIcon={<UilSearch size={15} color="#8F8F8F" />}
        icon={
          close && (
            <Button
              content="icon-only"
              icon={<UilTimes color="#8F8F8F" />}
              action={closeAction}
              variant="transparent"
              theme="gray-davys"
            >
              ic
            </Button>
          )
        }
      />
      {show && withList ? (
        <List className={`${label.length > 0 ? "top-16" : "top-12"} w-full`}>
          {resultOnfilter.map((item, i) => {
            return (
              <ListItem action={() => onSelectDefault(item.label)} key={i}>
                {item.label}
              </ListItem>
            );
          })}
        </List>
      ) : (
        ""
      )}
    </div>
  );
};

SearchBar.propTypes = {
  withList: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  close: PropTypes.bool,
  closeAction: PropTypes.func,
  onChange: PropTypes.func,
  onClickSearch: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SearchBar;
